import { useCallback } from 'react';
import { getIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Tooltip } from '../../../../feedback/Tooltip';
import { IconPurchases20 } from '../../../../icon/IconPurchases20';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { CHECKOUT_MORE_LINK } from './constants';
import { CheckoutBadgeProps } from './typings';

export const CheckoutBadge = ({ onClick }: CheckoutBadgeProps) => {
    const t = useTranslation();
    const { isMobile } = getIsMobile();
    const onTooltipClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }, []);

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            onClick();
        },
        [onClick],
    );

    const trigger = (
        <Flex
            width={36}
            height={36}
            alignItems="center"
            justifyContent="center"
            p={1}
            borderRadius={999}
            background="var(--search-red)"
            dataTestId={DataTestId.CHECKOUT_BADGE}
            onClick={handleClick}
        >
            <IconPurchases20 size={20} color="var(--always-white)" />
        </Flex>
    );

    if (isMobile) {
        return trigger;
    }

    return (
        <Tooltip variant="onboarding" options={{ placement: 'bottom' }} trigger={trigger}>
            <Box py={0.5} onClick={onTooltipClick} dataTestId={DataTestId.CHECKOUT_BADGE_TOOLTIP}>
                <Typography variant="body" weight="bold" color="invert" loose>
                    {t('Можно купить в 1 клик')}
                </Typography>
                <br />
                <Typography variant="body" color="invert" loose>
                    {t(
                        'Перед оформлением заказа попросим подтвердить адрес доставки и способ оплаты',
                    )}
                </Typography>
                <br />
                <Typography
                    as="a"
                    target="_blank"
                    width="fit-content"
                    href={CHECKOUT_MORE_LINK}
                    rel="noopener noreferrer"
                    variant="body"
                    color="var(--color-secondary-invert)"
                    loose
                >
                    {t('Подробнее')}
                </Typography>
            </Box>
        </Tooltip>
    );
};
